import { Button, Card, Divider, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import React, { useCallback, useContext, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { formatClassification } from '../../util/formatClassification';
import { EditCircle, InfoCircle, QuestionMarkCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import { DE_INSTALL_HELP, DE_INSTALLED_PROD_UNIT, helperTexts } from '../../util/helperTexts';
import { formatDate, mmOrInch, mmOrMiles, round, getSiteType, getExpressions, renderTemperatureCut } from '../../util/helperFunctions';
import { useEvalMetrics } from '../../util/hooks/useEvalMetrics';
import UpdateRatingModal from './components/UpdateRatingModal';
import { findAvgPredDateRange, findFirstAndLastDate, findLastDate, findLastValue, findMinMaxMissingValuesInTrainPeriod } from './utils/infoUtils';
import useFetchSensorInfo from './hooks/useFetchSensorInfo';
import useFetchAlertCount from './hooks/useFetchAlertCount';
import useFetchPredAlertCount from './hooks/useFetchPredAlertCount';
import useFetchSensorLife from './hooks/useFetchSensorLife';
import { UserContext } from '../../App';
import { messagePredictions } from './utils/predMsg';
import renderInfoData from './components/RenderInfoData';
import { INT_USER_ROLES } from '../../util/constants';
import { AuthContext } from '../../AuthProvider';
//import { info } from 'pdfjs-dist/types/src/shared/util';


const helpContents = helperTexts.sensorInfo;
const infoHelp = helperTexts.infoPanel;
import * as R from "rambda";

const SensorInfoPanel = (
    {
        units,
        prodUnit,
        isRealSensor,
        sensorID,
        site,
        alertThresholdUpdate,
        start,
        end,
        forecastMonths,
    }
) => {

    const [ratingUpdated, setRatingUpdated] = useState(false);

    const { isNorcoWest, isNorcoEast, isRhienland, isSyngas, isBonga, isScotfordHCU, isBukom } = getSiteType(site, prodUnit);
    const MeasuredWallThicknessMetric = "MeasuredWallThickness"; 
    const PredictedWallThicknessMetric = "LiveModelWallThickness";


    // Memoize the expressions function to prevent unnecessary re-renders
    const expressions = useCallback(() => getExpressions(isRhienland, ["MissingAvailability"]), [isRhienland]);
    // Include "MissingAvailability" as an additional metric
    const eval_data = useEvalMetrics(
        "SensorExpression",
        sensorID,
        null,
        expressions
    );

    const { lifeExpectancyInYears } = useFetchSensorLife(sensorID, start, end, forecastMonths)
    const { infopanel_data, train_period } = useFetchSensorInfo(sensorID, ratingUpdated);
    // const { actual_alert_data } = useFetchAlertCount(sensorID, alertThresholdUpdate);
    // const { pred_alert_data } = useFetchPredAlertCount(sensorID, alertThresholdUpdate)
    const actual_alert_data = null
    const pred_alert_data = null  //TODO: to be implemented
    const authContext = useContext(AuthContext)
    const role = authContext.role;
    const userContext = useContext(UserContext);
    const userData = userContext?.userData;

    const isUserTAO = INT_USER_ROLES.includes(role) || false; // Check if user is TAO

    const [commentLoading, setCommentLoading] = useState(false)
    const [openRatingModal, setOpenRatingModal] = useState(false);

    const renderLocationDetails = () => (
        <div className='info-details' id='sensor-info-id-7'>
            <h4 id='sensor-info-id-140'>Location</h4>
            <div className='info-details-body' id='sensor-info-id-8'>
                <div className='data-col' id='sensor-info-id-9'>

                    {renderInfoData("Site", R.path(["siteName"], infopanel_data))}
                    {renderInfoData("Prod Unit", R.path(["plant"], infopanel_data))}
                    {renderInfoData("Unit", R.path(
                        ["unit"],
                        infopanel_data
                    ))}
                    {renderInfoData("Equipment", R.path(["equipment"], infopanel_data))}
                    {renderInfoData("Corrosion Loop", <Link
                        className="link"
                        to={`/cls/${encodeURIComponent(
                            R.path(["corrosionLoop"], infopanel_data)
                        )}/details`}
                        id='sensor-info-id-25'
                    >
                        {R.path(["corrosionLoop"], infopanel_data)}
                    </Link>)}
                    {renderInfoData("CML", <Link
                        id='sensor-info-id-29'
                        className="link"
                        to={`/cmls/${encodeURIComponent(
                            R.path(["cmLocation"], infopanel_data)
                        )}/details`}
                    >
                        {R.path(["cmLocationName"], infopanel_data)}
                    </Link>)}
                    {renderInfoData("Sensor", <>
                        <span
                            id='sensor-info-id-33'
                            className={
                                R.path(["uninstalled"], infopanel_data) ? "redContent" : ""
                            }
                            title={
                                R.path(["uninstalled"], infopanel_data)
                                    ? R.path(["plant"], infopanel_data) ===
                                        DE_INSTALLED_PROD_UNIT
                                        ? DE_INSTALL_HELP.bukam
                                        : DE_INSTALL_HELP.other
                                    : ""
                            }
                        >
                            {" "}
                            {R.path(["isRealSensor"], infopanel_data) &&
                                R.path(["name"], infopanel_data)}{" "}
                        </span>{" "}
                        {!R.path(["isRealSensor"], infopanel_data) && (
                            <span
                                id='sensor-info-id-34'
                                title="This CML has no Sensor installed"
                                className="redContent"
                            >
                                No Sensor
                            </span>
                        )}</>)}
                </div>
            </div>
        </div>
    )

    const renderGeneralDetails = () => (
        <div className='info-details' id='sensor-info-id-37'>
            <h4 id='sensor-info-id-38'>General</h4>
            <div className='info-details-body' id='sensor-info-id-39'>
                <div className='data-col' id='sensor-info-id-40'>
                    {renderInfoData("Minimum Required wall thickness", <>
                        {units
                            ? round(
                                0.0393700787 *
                                R.path([ "minimumWallThickness"], infopanel_data),
                                3
                            )
                            : round(
                                R.path([ "minimumWallThickness"], infopanel_data),
                                3
                            )}{" "}
                        {mmOrInch(units)}</>)}
                    {(!isRhienland && !isNorcoEast && !isBukom) && renderInfoData("Nominal wall thickness", <>
                        {units
                            ? round(
                                0.0393700787 *
                                R.path([ "nominalWallThickness"], infopanel_data),
                                3
                            )
                            : round(
                                R.path([ "nominalWallThickness"], infopanel_data),
                                3
                            )}{" "}
                        {mmOrInch(units)}</>)}
                    {isSyngas || isBonga || isNorcoEast || isScotfordHCU ? null : renderInfoData(
                        "Temperature Cut", renderTemperatureCut(
                            R.path([ "cut"], infopanel_data),
                            units
                        )
                    )}
                    {renderInfoData("Material", R.path([ "material"], infopanel_data))}
                    {renderInfoData("Position", R.path([ "position"], infopanel_data))}
                    {renderInfoData("Fluid", R.path([ "fluid"], infopanel_data))}
                    {R.path([ "pipeDiameter"], infopanel_data) && renderInfoData("Pipe diameter", <>
                        {units
                            ?
                            R.path([ "pipeDiameterInch"], infopanel_data)
                            :
                            R.path([ "pipeDiameter"], infopanel_data)

                        }{" "}
                        {mmOrInch(units)}
                    </>)}

                    {R.path(
                        [ "nominalAcceptedCR"],
                        infopanel_data
                    ) && renderInfoData("Suggested CR", <>
                        {units
                            ? round(
                                39.3700787402 *
                                R.path(
                                    [ "nominalAcceptedCR"],
                                    infopanel_data
                                ),
                                3
                            )
                            : round(
                                R.path(
                                    [ "nominalAcceptedCR"],
                                    infopanel_data
                                ),
                                3
                            )}{" "}
                        {mmOrMiles(units)}
                    </>)
                    }
                </div>
            </div>
        </div>
    )

    const renderMeasurementDeatils = () => (
        <div className='info-details' id='sensor-info-id-64'>
            <h4 id='sensor-info-id-65'>Measurements</h4>
            <div className='info-details-body' id='sensor-info-id-66'>
                <div className='data-col' id='sensor-info-id-67'>
                    {renderInfoData("Last measured wall thickness", <>
                        {units
                            ? round(0.0393700787 * R.path(["lastWallThicknessMeasurement"], infopanel_data), 3)
                            : round(R.path(["lastWallThicknessMeasurement"], infopanel_data),
                                3
                            )}{" "}
                        {mmOrInch(units)}{" "}
                        <span className="titleLabelDate" id='sensor-info-id-85'>
                            {formatDate(new Date(R.path(["lastWallThicknessMeasurementDate"], infopanel_data)))}
                        </span>
                    </>)}
                </div>
            </div>
        </div>
    )

    const renderPredictionDetails = () => (
        <div className='info-details' id='sensor-info-id-78'>
            <h4 id='sensor-info-id-79'>Predictions</h4>
            <div className='info-details-body' id='sensor-info-id-80'>
                <div className='data-col' id='sensor-info-id-81'>
                    {renderInfoData("Current wall thickness", <>
                        {units
                            ? round(0.0393700787 * findLastValue(eval_data, PredictedWallThicknessMetric, sensorID), 3)
                            : round(
                                findLastValue(eval_data, PredictedWallThicknessMetric, sensorID),
                                3
                            )}{" "}
                        {mmOrInch(units)}{" "}
                        <span className="titleLabelDate" id='sensor-info-id-85'>
                            {findLastDate(eval_data, PredictedWallThicknessMetric, sensorID)}
                        </span>
                    </>, infoHelp.CurrentWallThickness)}

                    {renderInfoData("Current corrosion rate", <>
                        {units
                            ? round(
                                39.3700787402 *
                                R.path(
                                    ["latestCorrosionRatePredictionFromLiveModel"],
                                    infopanel_data
                                ),
                                3
                            )
                            : round(
                                R.path(
                                    ["latestCorrosionRatePredictionFromLiveModel"],
                                    infopanel_data
                                ),
                                3
                            )}{" "}
                        {mmOrMiles(units)}{" "}
                        <span className="titleLabelDate" id='sensor-info-id-85'>
                            {units ? findLastDate(eval_data, "LiveModelPredictedWallThickness_HCU", sensorID)
                                : findLastDate(eval_data, PredictedWallThicknessMetric, sensorID)}
                        </span>
                    </>, infoHelp.CurrentCorrosionRates)}

                    {renderInfoData("Average corrosion rate", <>
                        {units
                            ? round(
                                39.3700787402 *
                                R.path(
                                    ["averageCorrosionRatePredictionFromLiveModel"],
                                    infopanel_data
                                ),
                                3
                            )
                            : round(
                                R.path(
                                    ["averageCorrosionRatePredictionFromLiveModel"],
                                    infopanel_data
                                ),
                                3
                            )}{" "}
                        {mmOrMiles(units)}{" "}
                        <span className="titleLabelDate" id='sensor-info-id-85'>
                            {units ? findAvgPredDateRange(eval_data, "LiveModelPredictedWallThickness_HCU", sensorID)
                                : findAvgPredDateRange(eval_data, PredictedWallThicknessMetric, sensorID)}
                        </span>
                    </>, infoHelp.AverageCorrosionRate)}
                </div>
            </div>
        </div>
    )

    const renderModelDetails = () => (
        <div className='info-details' id='sensor-info-id-92'>
            <h4 id='sensor-info-id-93'>Model</h4>
            <div className='info-details-body' id='sensor-info-id-94'>
                <div className='data-col' id='sensor-info-id-95'>
                    {renderInfoData("R2 Score", round(R.path(
                        ["latestR2Score"],
                        infopanel_data
                    ), 3))}
                    {renderInfoData("R2 WT Score", round(R.path(
                        ["latestR2WTScore"],
                        infopanel_data
                    ), 3))}
                    {renderInfoData("MSE Score", round(R.path(
                        ["latestMseScore"],
                        infopanel_data
                    ), 3))}

                    <div className='info-data' id='sensor-info-id-105'>
                        <p className='data-label' id='sensor-info-id-106'>Rating</p>
                        <div className='data-help' id='sensor-info-id-107'>
                            {!commentLoading && <p className='data-value' id='sensor-info-id-108'>
                                {formatClassification(
                                    R.path(
                                        ["sensorRating"],
                                        infopanel_data
                                    )
                                )}
                            </p>}

                            {R.path(
                                ["ratingComment"],
                                infopanel_data) &&

                                <Tooltip id='sensor-info-id-909' className='tooltip' placement='bottom' overlay={<div id='sensor-info-id-910' className='tooltip-content'>{R.path(
                                    ["ratingComment"],
                                    infopanel_data)}</div>} trigger={
                                        <Button id='sensor-info-id-911' size='xsmall' variant='transparent' iconOnly icon={<QuestionMarkCircle />} />
                                    } />}
                            {isUserTAO && <Button id='sensor-info-id-1111' size='xsmall' variant='transparent' onClick={() => setOpenRatingModal(true)} iconOnly icon={<EditCircle />} />}
                            <Tooltip id='sensor-info-id-109' className='tooltip' placement='bottom' overlay={<div id='sensor-info-id-110' className='tooltip-content'>{isNorcoWest ? helpContents.norco : !R.path(["isRealSensor"], infopanel_data) ? helpContents.noSensorRating : helpContents.sensorRating}</div>} trigger={
                                <Button id='sensor-info-id-111' size='xsmall' variant='transparent' iconOnly icon={<InfoCircle />} />
                            } />
                        </div>
                    </div>
                    {renderInfoData("Start of traindata", formatDate(new Date(R.path(["start"], infopanel_data))))}
                    {renderInfoData("End of traindata", formatDate(new Date(R.path(["end_date"], infopanel_data))))}
                    {renderInfoData("Available features over train period", <>
                        {findMinMaxMissingValuesInTrainPeriod(
                            eval_data,
                            "MissingAvailability",
                            sensorID, {start: R.path(["start"], infopanel_data), end: R.path(["end_date"], infopanel_data)}
                        )}
                        <span className="warningError" data-testid="model-message" id='sensor-info-id-121'>
                            <span id='sensor-info-id-122'>
                                {messagePredictions(
                                    R.path(
                                        ["latestMseScore"],
                                        infopanel_data
                                    ) || "NA",
                                    R.path(
                                        ["latestR2Score"],
                                        infopanel_data
                                    ) || "NA",
                                    R.path(
                                        ["latestMSEWTScore"],
                                        infopanel_data
                                    ) || "NA",
                                    R.path(
                                        ["latestR2WTScore"],
                                        infopanel_data
                                    ) || "NA"
                                )}
                            </span>
                        </span>
                    </>)}
                </div>
            </div>
        </div>
    )

    const renderAlertDetails = () => (
        <div className='info-details' id='sensor-info-id-125'>
            <h4 id='sensor-info-id-126'>Alerts</h4>
            <div className='info-details-body' id='sensor-info-id-127'>
                <div className='data-col' id='sensor-info-id-128'>
                    {isRealSensor && renderInfoData("Measured corrosion rate alerts", <>
                        {actual_alert_data}{" "}
                        <span className="titleLabelDate" id='sensor-info-id-132'>
                            {R.path(
                                    ["latestCorrosionRatePredictionFromLiveModel"],
                                    infopanel_data
                                )
                                    ? findFirstAndLastDate(eval_data, "MeasuredCorrosionRate", sensorID)
                                    : ""}
                        </span>
                    </>)}
                    {renderInfoData("Predicted corrosion rate alerts", <>
                        {pred_alert_data}{" "}
                        <span className="titleLabelDate" id='sensor-info-id-136'>
                            {R.path(
                                    ["latestCorrosionRatePredictionFromLiveModel"],
                                    infopanel_data
                                )
                                    ? findFirstAndLastDate(
                                        eval_data,
                                        "LiveModelCorrosionRate",
                                        sensorID
                                    )
                                    : ""}
                        </span>
                    </>)}
                    {renderInfoData("Expected year for End of Life", round(lifeExpectancyInYears, 0), infoHelp.ExpectedEOF)}
                </div>
            </div>
        </div>
    )

    return (
        <div className='info-content-container' id='sensor-info-id-2'>
            <div className='content-body' id='sensor-info-id-4'>
                <Card className='details-card' bodyPadding={false} id='sensor-info-id-5'>
                    <div className='details-card-body' id='sensor-info-id-6'>
                        {renderLocationDetails()}
                        <div className='details-container' id='sensor-info-id-35'>
                            <Divider direction='vertical' className='vertical-divider' id='sensor-info-id-36' />
                            {renderGeneralDetails()}
                        </div>
                        <div className='details-container' id='sensor-info-id-62'>
                            <Divider direction='vertical' className='vertical-divider' id='sensor-info-id-63' />
                            {renderMeasurementDeatils()}
                        </div>
                        <div className='details-container' id='sensor-info-id-76'>
                            <Divider direction='vertical' className='vertical-divider' id='sensor-info-id-77' />
                            {renderPredictionDetails()}
                        </div>
                        <div className='details-container' id='sensor-info-id-90'>
                            <Divider direction='vertical' className='vertical-divider' id='sensor-info-id-91' />
                            {renderModelDetails()}
                        </div>
                        <div className='details-container' id='sensor-info-id-123'>
                            <Divider direction='vertical' className='vertical-divider' id='sensor-info-id-124' />
                            {renderAlertDetails()}
                        </div>
                    </div>
                </Card>
            </div>
            <UpdateRatingModal openRatingModal={openRatingModal} sensorID={sensorID}
                setCommentLoading={setCommentLoading} setOpenRatingModal={setOpenRatingModal}
                setRatingUpdated={setRatingUpdated} userData={userData} />
        </div >
    )
}

export default SensorInfoPanel